import React, { useContext, useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { baseUrl, path } from '../../constants'
import { Oval } from 'react-loader-spinner'
import { appContext } from '../../Context/appProvider'
import { Controller, useForm } from 'react-hook-form';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import VideocamIcon from '@mui/icons-material/Videocam';
import Select from 'react-select';
import { useQuery } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SubSection from './SubSection'
import Materials from './Materials'
import {api} from '../../api'

export default function Sections() {
     const [uploading, setUploading] = useState(false)
     const [sources, setSources] = useState()
     const [files, setFiles] = useState([])
     const [categories, setCategories] = useState([])
     const [instructors, setInstructors] = useState([])
     const [selectedCategory, setSelectedCategory] = useState(null)
     const [submitting, setSubmitting] = useState(false)
     const [selectedSection, setSelectedSection] = useState(null)
     const [selectedSubSection, setSelectedSubSection] = useState(null)
     const [selectedMaterials, setSelectedMaterials] = useState(null)

     const fileRef = useRef()
     const {setNotification} = useContext(appContext)
     const [name, setName] = useState()
     const {id} = useParams()
     const [loading, setLoading] = useState(false)
     const navigate = useNavigate()
     

     const { isLoading, error, data, refetch } = useQuery('fetchSections', () =>
        api(path.getSections + '/' + id, {
        })
    )
    const [readyState, setReadyState] = useState(0)

   console.log('ddd')

    useEffect(() => {
        if(data){
            setReadyState(data?.data?.readyState)
        }
    }, [data])

     const uploadImage = (event) => {
        setFiles([event.target.files[0]])
     }

     const readyCourse = (action) => {
         setLoading(true)
         api.post(path.readyState, {id, action}).then(response => {
             let data = response.data
             if(data.success){
                setNotification({
                    message: 'Success!',
                    visible: true,
                    type: 'success'
                })
                navigate(-1)
            }
         }).finally(() => setLoading(false))
     }

    return (
    <div className='flex flex-col gap-5 h-full w-full bg-white rounded-sm p-4 overflow-y-auto'>
        <div className='flex justify-between'>
            <h2 className='text-black text-[18px] font-bold'>Course Sections</h2>
            <div className='flex items-center gap-4'>
                <button onClick={() => readyCourse('approve')} disabled={loading} className='text-white text-[14px] px-4 py-2 bg-main font-bold rounded-sm'>
                    {loading ? (
                        <Oval
                            visible={true}
                            height="21"
                            width="21"
                            color="#ffffff"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            strokeWidth={3}
                        />
                    ) : 'Approve'}
                </button>
                <button onClick={() => readyCourse('reject')} disabled={loading} className='text-white text-[14px] px-4 py-2 bg-[#ff0000] font-bold rounded-sm'>
                    {loading ? (
                        <Oval
                            visible={true}
                            height="21"
                            width="21"
                            color="#ffffff"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            strokeWidth={3}
                        />
                    ) : 'Reject'}
                </button>
            </div>
        </div>
        <div className='flex-1 flex p-5 border-[1px] border-solid border-[#00000050] overflow-y-auto'>
            {/* <div className='flex-1 flex flex-col gap-3'>
                <div className='flex items-center gap-1'>
                    <h2 className='text-[#00000095] text-[16px] font-bold'>{ 'Add Section'}</h2>
                </div>
                <div className='flex flex-col gap-3 w-[400px]'>
                    <input value={name} onChange={event => setName(event.target.value)} placeholder={ 'Section Title'} type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    <button disabled={!name || submitting} onClick={ addSection} type='submit' className={`${(!name) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] w-full p-2 flex items-center justify-center`}>
                    {submitting ? (
                        <Oval
                            visible={true}
                            height="21"
                            width="21"
                            color="#ffffff"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            strokeWidth={3}
                        />
                    ) : 'Create'}
                    </button>
                </div>
            </div> */}
            <div className='flex-1 flex gap-5 flex-col overflow-y-auto'>
                <div className='flex justify-between items-center'>
                    <h2 className='text-[#00000095] text-[16px] font-bold'>Sections</h2>
                </div>
                {!data?.data?.sections?.length && <p className='text-[12px] text-[#00000090]'>There are no sections in this course.</p>}
                {isLoading ? (
                    <div className='flex flex-col gap-3 flex-1 items-center justify-center'>
                        <p className='text-[16px]'>Loading section items...</p>
                        <Oval
                            visible={true}
                            height="30"
                            width="30"
                            color="#198754"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            strokeWidth={3}
                        />
                    </div>
                    ) : data?.data?.sections?.map((section, id) => (
                    <div className='flex flex-col gap-3 border-l-[1px] border-[#00000095] p-3'>
                        <div className='flex gap-3 items-center'>
                            <div className='w-[30px] h-[30px] rounded-full bg-[#00000050] flex items-center justify-center'>
                                <p className='text-[14px] text-black font-bold'>{id + 1}</p>
                            </div>
                            <p className='text-[17px] font-bold text-black'>{section.name}</p>
                            <div className='flex gap-2 items-center ml-auto'>
                                <button onClick={() => setSelectedMaterials(section.id)} className='bg-main whitespace-nowrap text-white text-[14px] font-bold  rounded-sm px-2 py-1 outline-none border-none'>
                                    <FilePresentIcon style={{fontSize: 17, marginRight: 5}}>Filled</FilePresentIcon>
                                    Materials <font style={{}}>({section.materials?.length})</font>
                                </button>
                                   
                            </div>
                        </div>
                        <div className='p-3 pl-5 ml-8 border-l-[1px] flex flex-col gap-5 border-[#00000095]'>
                        {section.subsections.map((subsection, id) => (
                            <div className='flex items-center gap-8'>
                                <p className='text-[16px] text-black'>{subsection.name}</p>
                                <button onClick={() =>  setSelectedSubSection({id: subsection.id, title: subsection.name})} className={`bg-main 'bg- whitespace-nowrap text-white text-[14px] font-bold  rounded-sm px-2 py-1 outline-none border-none`}>
                                    {/* <VideocamIcon style={{fontSize: 17, marginRight: 5}}>Filled</VideocamIcon> */}
                                    {/* bg-[#f45050] */}
                                    View Sub-Section
                                </button>
                            </div>
                        ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>

        {/* {selectedSection && <AddSubSection section={selectedSection} refetch={refetch} setNotification={setNotification} setSelectedSection={setSelectedSection} /> } */}
        {selectedSubSection && <SubSection sectionId={selectedSubSection} setSelectedSubSection={setSelectedSubSection} /> }
        {selectedMaterials && <Materials sectionId={selectedMaterials} setSelected={setSelectedMaterials} /> }
    </div>
    )
}

function UploadItem({ file, setUploading, setSources }){
    const [loading, setLoading] = useState(true)
    const [source, setSource] = useState(null)

    useEffect(() => {
        setLoading(true)
        let form  = new FormData()
        form.append('file', file)
        console.log(file)
        api(path.uploadFile + '?to=images', {
            data: form,
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.success){
                setLoading(false)
                setSource(response.data.source)
                setSources(response.data.source)
            }
        })
    }, [file])

    return (
        <div className='w-[50px] h-[50px] border-[#00000050] border-solid border-[1px] p-1 flex items-center justify-center'>
            {loading ? (
                <Oval
                    visible={true}
                    height="24"
                    width="25"
                    color="#198754"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                /> ): (
                    <img src={baseUrl + source} alt='source' className='w-full h-full object-contain'  />
                )}
        </div>
    )
}

function AddSubSection({ section, refetch, setNotification, setSelectedSection }){
    const [name, setName] = useState(null)
    const [submitting, setSubmitting] = useState(false)

    const addSubSection = () => {
        setSubmitting(true)
        api(path.addSubSection + '/' + section?.id, {
            method: 'post',
            data: {
                name,
            }
        }).then(response => {
            setName(null)
            setSubmitting(false)
            if(response.data.success){
                setNotification({
                    message: 'Sub-Section successfully added!',
                    visible: true,
                    type: 'success'
                })
                refetch()
                setSelectedSection(null)
            } else {
                setNotification({
                    message: response.data.message,
                    visible: true,
                    type: 'error'
                })
            }
        })
    }

    return (
        <div className='fixed bg-[#00000060] inset-0 flex items-center justify-center'>
            <div className='bg-white flex flex-col items-center gap-6 p-4 rounded-md'>
                <h1>Add Sub Section for (<span className='text-[#ff0000] font-bold'>{section?.title}</span>)</h1>
                <input value={name} onChange={event => setName(event.target.value)} placeholder={'Sub-Section Title'} type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-[300px]' />
                <div className='flex self-stretch gap-2'>
                    <button disabled={!name || submitting} onClick={addSubSection} type='submit' className={`${(!name) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] flex-1 p-2 flex items-center justify-center`}>
                    {submitting ? (
                            <Oval
                                visible={true}
                                height="21"
                                width="21"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) : 'Create'}
                    </button>
                    <button onClick={() => setSelectedSection(null)} className='border-[1px] border-[#00000070] p-2 text-[14px] flex-1'>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
}